<footer id="footer" class="footer" role="contentinfo">
  <div class="fixed">
    <div class="white-block margin-block-small">
      <div class="text-center mb-3">
        <h4><b>Join Our Newsletter</b></h4>
        <div class="description">Stay up to date with our latest news and deals</div>
      </div>
      <form name="signup" id="signup" autocomplete="off" (submit)="$event.preventDefault()">
        <div class="row">
          <div class="col-12 col-sm-4 order-1">
            <input
              type="email"
              name="email"
              id="email"
              required
              placeholder="Email"
              class="w-100"
            />
          </div>
          <div class="col-12 col-sm-4 order-2">
            <input
              type="text"
              class="text w-100"
              name="cd_FIRSTNAME"
              id="FIRSTNAME"
              required
              placeholder="First Name"
            />
          </div>
          <div class="col-12 order-3 order-sm-4">
            <input type="checkbox" name="ci_userConsentCheckBox" id="ci_userConsentCheckBox" />
            <label for="ci_userConsentCheckBox">
              <small>
                <small>
                  By signing up, you agree to receive emails from ibranson.com about area promotions
                  and news of things to do in Branson, MO. You can unsubscribe at any time by
                  clicking the link in the footer of our emails.
                </small>
              </small>
            </label>
          </div>
          <div class="col-12 col-sm-4 order-4 order-sm-3">
            <input
              type="submit"
              id="btnsubmit"
              name="btnsubmit"
              value="Subscribe"
              class="btn btn-secondary w-100"
            />
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="footer-bg">
    <div class="fixed">
      <ul class="menu-footer">
        <li><a href="#" (click)="$event.preventDefault()">Home</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Shows</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Attractions</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Lodging</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Dining</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Packages</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Deals</a></li>
        <li><a href="#" (click)="$event.preventDefault()">Contact Us</a></li>
      </ul>
      <div class="social-links">
        <a href="#" title="Facebook" (click)="$event.preventDefault()">
          <span class="icon ibranson-fontawesome-webfont-3"></span>
        </a>
        <a href="#" title="Twitter" (click)="$event.preventDefault()">
          <span class="icon ibranson-fontawesome-webfont-5"></span>
        </a>
        <a href="#" title="Youtube" (click)="$event.preventDefault()">
          <span class="icon ibranson-fontawesome-webfont-1"></span>
        </a>
      </div>
      <div class="phone">
        <div>Call to Book</div>
        <span class="icon ib-phone"></span>
        <a href="#" (click)="$event.preventDefault()">1-877-368-3782</a>
      </div>
      <div class="copyright">
        <div>© 2026 Tripium, LLC. Powered by Tripium. All rights reserved</div>
        <a href="#" (click)="$event.preventDefault()">Terms of service</a>
        <a href="#" (click)="$event.preventDefault()">Privacy policy</a>
        <a href="#" (click)="$event.preventDefault()">Cookies Policy</a>
      </div>
    </div>
  </div>
</footer>
